import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';
import BookMakeUpSessionPage from './BookMakeUpSessionPage';

// ============================================================================
// BOOK MAKE UP SESSION PAGE WRAPPER - GET ALL PARAMS
// ============================================================================

interface BookMakeUpSessionPageWrapperProps extends WithTranslation {
  // Props will be passed through to BookMakeUpSessionPage
}

const BookMakeUpSessionPageWrapper: React.FC<BookMakeUpSessionPageWrapperProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract all navigation parameters from URL query string (match reference navigation.getParam)
  const searchParams = new URLSearchParams(location.search);
  const state = location.state as any;
  
  // All required parameters for BookMakeUpSessionPage (match reference implementation)
  const leave_id = searchParams.get('leave_id') || state?.leave_id || '';
  const categoryId = searchParams.get('categoryId') || state?.categoryId || '';
  const code = searchParams.get('code') || state?.code || '';
  const isStudent = searchParams.get('isStudent') === 'true' || state?.isStudent || false;
  const isTherapist = searchParams.get('isTherapist') === 'true' || state?.isTherapist || false;
  const isReschedule = searchParams.get('isReschedule') === 'true' || state?.isReschedule || false;
  const make_id = searchParams.get('make_id') || state?.make_id || '';
  const therapist_leave_id = searchParams.get('therapist_leave_id') || state?.therapist_leave_id || '';
  const paramsForUpdateMake = searchParams.get('paramsForUpdateMake') || state?.paramsForUpdateMake || '';
  
  // Navigation functions (match reference navigation object)
  const handleNavigate = (path: string, params?: any) => {
    if (params) {
      // Convert params to query string for better web parameter management
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });
      const queryString = queryParams.toString();
      navigate(queryString ? `${path}?${queryString}` : path);
    } else {
      navigate(path);
    }
  };
  
  const handleGoBack = () => {
    navigate(-1);
  };
  
  // Debug logging for development
  if (process.env.NODE_ENV === 'development') {
    console.log('BookMakeUpSessionPageWrapper - All params:', {
      leave_id,
      categoryId,
      code,
      isStudent,
      isTherapist,
      isReschedule,
      make_id,
      therapist_leave_id,
      paramsForUpdateMake,
      locationState: state,
      searchParams: Object.fromEntries(searchParams.entries()),
      fullLocation: location
    });
  }
  
  return (
    <BookMakeUpSessionPage
      {...props}
      // Pass all navigation parameters as props (match reference)
      leave_id={leave_id}
      categoryId={categoryId}
      code={code}
      isStudent={isStudent}
      isTherapist={isTherapist}
      isReschedule={isReschedule}
      make_id={make_id}
      therapist_leave_id={therapist_leave_id}
      paramsForUpdateMake={paramsForUpdateMake}
      location={location}
      navigate={handleNavigate}
      goBack={handleGoBack}
    />
  );
};

export default withTranslation()(BookMakeUpSessionPageWrapper);
